// Shared helper for grouping menu items by their `category` field.
// Categories appear in `categoryOrder` first (if provided), then any remaining
// categories follow in the order their first item appears in `items`.
// Uncategorised items collect under "Other" (always rendered last).
// If `popularIds` is provided, a virtual "Popular this week" group is prepended
// (items still appear in their normal category too — popular is a shortcut).

export const UNCATEGORISED_LABEL = "Other";
export const POPULAR_LABEL = "Popular this week";

export const groupItemsByCategory = (items = [], categoryOrder = [], popularIds = [], descriptions = {}) => {
    const buckets = {};
    const firstSeen = [];
    for (const it of items) {
        const key = (it.category || "").trim() || UNCATEGORISED_LABEL;
        if (!buckets[key]) {
            buckets[key] = [];
            firstSeen.push(key);
        }
        buckets[key].push(it);
    }

    const order = [];
    const used = new Set();
    for (const cat of categoryOrder) {
        if (buckets[cat] && !used.has(cat) && cat !== UNCATEGORISED_LABEL) {
            order.push(cat);
            used.add(cat);
        }
    }
    for (const cat of firstSeen) {
        if (!used.has(cat) && cat !== UNCATEGORISED_LABEL) {
            order.push(cat);
            used.add(cat);
        }
    }
    if (buckets[UNCATEGORISED_LABEL]) order.push(UNCATEGORISED_LABEL);

    const result = order.map((cat) => ({
        category: cat,
        items: buckets[cat],
        description: (descriptions || {})[cat] || "",
    }));

    // Prepend "Popular this week" virtual group if we have ids
    if (popularIds && popularIds.length) {
        const byId = Object.fromEntries(items.map((it) => [it.id, it]));
        const popItems = popularIds.map((id) => byId[id]).filter(Boolean);
        if (popItems.length) {
            result.unshift({
                category: POPULAR_LABEL,
                items: popItems,
                description: "Top sellers in the last 7 days",
                isPopular: true,
            });
        }
    }
    return result;
};
